import { z } from "zod";

export const privacySettingsSchema = z.object({
  analytics: z.boolean(),
  recommendations: z.boolean(),
  locationServices: z.boolean(),
  crashReports: z.boolean(),
  promotionalEmails: z.boolean(),
});
export type PrivacySettings = z.infer<typeof privacySettingsSchema>;
